import BuyerDeals from './BuyerDeals.component';

export default BuyerDeals;